import { useEffect, useState } from "react";
import type { PublicCounts } from "@akhshy/types";
import { client } from "./api.ts";

/**
 * Public usage counts, fetched once per page load and shared by every card.
 * Failure is silent — the numbers are garnish, never worth an error state.
 */
let cache: PublicCounts | null = null;
let inflight: Promise<PublicCounts | null> | null = null;

function load(): Promise<PublicCounts | null> {
  if (cache) return Promise.resolve(cache);
  inflight ??= client.metrics
    .counts()
    .then((c) => (cache = c))
    .catch(() => null)
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

/** Count for one entry, or null while loading / when zero / on failure. */
export function useCount(kind: keyof PublicCounts, id: string): number | null {
  const [counts, setCounts] = useState<PublicCounts | null>(cache);
  useEffect(() => {
    if (!counts) void load().then(setCounts);
  }, [counts]);
  const n = counts?.[kind][id] ?? 0;
  return n > 0 ? n : null;
}
